export default "__VITE_ASSET__Bm_BoUgY__"